import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock } from "@fortawesome/pro-light-svg-icons";
import { usCurrency } from "../../../../utils";
import moment from "moment";

const data = {
  bankFundings: [
    {
      bankName: "Some",
      bankFund: 1000,
    },
    {
      bankName: "Koewe",
      bankFund: 1000,
    },
    {
      bankName: "Kerw",
      bankFund: 1000,
    },
    {
      bankName: "WRwef",
      bankFund: 1000,
    },
  ],
};
export const SourceInvestmentSplitup = (props) => {
  const [showBank, setShowBank] = useState(false);
  const bankTotal = 4000;
  return (
    <div className="transaction-history-withdrawal">
      <div className="transaction-history-withdrawal-header">
        Source & investment Splitup
      </div>
      <div className="transaction-history-withdrawal-inner-box">
        <div
          className="requested-amount"
          style={{ borderBottom: "0.5px solid #BDBDBD" }}
        >
          <div className="requested-text">Total Requested Amount</div>
          <div className="requested-text">$3000.00</div>
        </div>
        <div className="detailed-tree">
          <ul className="Payrolltree">
            {!isEmpty(data.bankFundings) && (
              <li>
                <div className="d-flex justify-content-start">
                  <div
                    className="ft-14"
                    style={{ width: "100%", color: "#307bf6" }}
                  >
                    <i
                      className={
                        showBank ? "far fa-minus-square" : "far fa-plus-square"
                      }
                      onClick={() => {
                        setShowBank(!showBank);
                      }}
                    />
                    Funding Via Bank
                  </div>
                  <div className="ft-14 fw-500">{usCurrency(bankTotal)}</div>
                </div>
                {showBank && (
                  <>
                    <ul>
                      {data.bankFundings.map((bank) => {
                        return (
                          <li className="tree-inner-flex">
                            <div className="ft-12 ml-4">{bank.bankName}</div>
                            <div className="ft-12">
                              {usCurrency(bank.bankFund)}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                )}
              </li>
            )}
          </ul>
          <ul className="Payrolltree">
            {!isEmpty(data.bankFundings) && (
              <li>
                <div className="d-flex justify-content-start">
                  <div
                    className="ft-14"
                    style={{ width: "100%", color: "#307bf6" }}
                  >
                    <i
                      className={
                        showBank ? "far fa-minus-square" : "far fa-plus-square"
                      }
                      onClick={() => {
                        setShowBank(!showBank);
                      }}
                    />
                    Funding Via Bank
                  </div>
                  <div className="ft-14 fw-500">{usCurrency(bankTotal)}</div>
                </div>
                {showBank && (
                  <>
                    <ul>
                      {data.bankFundings.map((bank) => {
                        return (
                          <li className="tree-inner-flex">
                            <div className="ft-12 ml-4">{bank.bankName}</div>
                            <div className="ft-12">
                              {usCurrency(bank.bankFund)}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                )}
              </li>
            )}
          </ul>
          <ul className="Payrolltree">
            {!isEmpty(data.bankFundings) && (
              <li>
                <div className="d-flex justify-content-start">
                  <div
                    className="ft-14"
                    style={{ width: "100%", color: "#307bf6" }}
                  >
                    <i
                      className={
                        showBank ? "far fa-minus-square" : "far fa-plus-square"
                      }
                      onClick={() => {
                        setShowBank(!showBank);
                      }}
                    />
                    Funding Via Bank
                  </div>
                  <div className="ft-14 fw-500">{usCurrency(bankTotal)}</div>
                </div>
                {showBank && (
                  <>
                    <ul>
                      {data.bankFundings.map((bank) => {
                        return (
                          <li className="tree-inner-flex">
                            <div className="ft-12 ml-4">{bank.bankName}</div>
                            <div className="ft-12">
                              {usCurrency(bank.bankFund)}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
